export default __webpack_public_path__ + "static/media/ic_product_donau-aktiv.51d6dcda.svg";